import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Box } from '@mui/material';
import ErrorScreen from '../../../../core-components/theme/components/ErrorScreen';
import Loader from '../../../../globalComponents/loader/DPLoader';
import PublicNavbar from '../../../../core-components/theme/components/HeaderComponents/PublicNavbar';
import InviteUserFormContainer from './PublicInviteUserFormContainer';

const InviteUserPage: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Box sx={{ width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <PublicNavbar />
        <Box sx={{ flex: 1, overflow: { xs: 'auto', md: 'hidden' }, mt: '64px', display: 'flex', flexDirection: 'column' }}>
          <Suspense fallback={<Loader />}>
            <InviteUserFormContainer />
          </Suspense>
        </Box>
      </Box>
    </ErrorBoundary>
  );
};

export default InviteUserPage;
